import { EAccountType } from '../repositories/offer-card/entities/agent/AgentSchema';
import { EAgentAccountType } from '../types/userData';

export const ACCOUNT_TYPE_NAME = {
  [EAgentAccountType.Agency]: 'Агентство',
  [EAgentAccountType.Developer]: 'Застройщик',
  [EAgentAccountType.Homeowner]: 'Пользователь',
  [EAgentAccountType.Management_company]: 'Управляющая компания',
  [EAgentAccountType.Rent_department]: 'Отдел аренды',
  [EAgentAccountType.Searcher]: 'Пользователь',
  [EAgentAccountType.Specialist]: 'Риелтор',
  [EAgentAccountType.System]: '',
  [EAccountType.ManagementCompany]: 'Управляющая компания',
  [EAccountType.RentDepartment]: 'Отдел аренды',
};
